import React, { useEffect, useMemo } from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import useTypedDispatch from '../../helpers/useDispatch';
import RelatedContent from '../RelatedContent';

export interface RelatedArticlesProps {
  targetId: number;
  display: string;
  title?: string;
  moreUrl?: string;
}

const RelatedArticles: React.FC<RelatedArticlesProps> = (props) => {
  const {
    targetId,
    display,
    title,
    moreUrl,
  } = props;

  const dispatch = useTypedDispatch();

  const articleEntities = useSelector<Immutable.Map<any, any>>(
    (state) => state.getIn(['view', 'article', display, 'entities'], Immutable.List()),
  ) as Immutable.List<any> || Immutable.List();

  const args = useMemo(() => [0, targetId], [targetId]);

  // Fetch the view before rendering to check if there are any results at all.
  useEffect(() => {
    if (articleEntities.size === 0) {
      dispatch(viewGet('article', display, 0, args));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (articleEntities.size === 0) {
    return null;
  }

  return (
    <RelatedContent className="RelatedArticles">
      {title && (
        <div className="row">
          <RelatedContent.Title
            className="col-lg-7"
            title={title}
          />
        </div>
      )}

      <RelatedContent.RelatedArticles
        display={display}
        args={args}
        viewClassName="row"
        itemClassName="col-lg-6"
      />

      <RelatedContent.MoreButton
        url={moreUrl}
      />
    </RelatedContent>
  );
};

export default RelatedArticles;
